module.exports = __webpack_public_path__ + "images/sprites/ui/arrow_bu_white_37d9a7aedb36015ae2a692811035ef21.png";